<template>
  <div class="header">
    <div class="header-container row-justify-center">
      <div class="header-brand row-center">
        <img src="@/images/logo.svg" alt="TIGA" class="logo"  @click="goHome"/>
      </div>
      <div class="header-options row-center" @click="showSettings">
         <!-- <svg class="icon--left">
          <use xlink:href="#icon-global-earth" />
        </svg>
        <span class="text">设置</span>  -->
        <md-icon name="setting" size="lg"></md-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon} from 'mand-mobile';
export default {
  components: {
    [Icon.name]: Icon,
  },
  methods: {
    goHome(){
      this.$router.push('/');
    },
    showSettings(){
      this.$router.push('/globalSettings');
    },
  },
};
</script>

<style lang="stylus" scoped>
.header-container {
  margin-right: 25vw;
  padding: 0 4.8vw;
  height: 11.73vw;
  color: color-text-gray;
}

.header-brand {
  .logo {
    height: 6.4vw;
  }
}

.header-options {
  .icon--left {
    icon-size(6.4vw);
  }

  .text {
    margin-left: 2.13vw;
  }

  .icon--right {
    icon-size(4.27vw);
  }
}

.title-bar {
  border-bottom: 0.27vw solid #eaf1f3;
}

</style>
